import React from 'react';
import { Header } from './Header';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../store/auth/auth.selector';
import { logOut } from '../store/auth/actions/logOut';
import { makeStyles } from '@material-ui/core';
import { Title } from './Title';
import { Container } from './helpers/Container';
import { Card, CardBody } from './Card';
import { Colors } from '../constants/colors';

import { Check } from '@material-ui/icons';
import { useMountEffect } from '../hooks/useMountEffect';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles({
  card: {
    textAlign: 'center',
    maxWidth: '100% !important',
    marginTop: 70
  },
  cardBody: {
    justifyContent: 'flex-start !important',
    alignItems: 'center'
  },
  colorSuccess: {
    color: Colors.success
  },
  paragraph: {
    color: Colors.dark,
    lineHeight: 2
  },
  successIcon: {
    marginLeft: 20,
    width: 40,
    height: 40,
    position: 'relative',
    top: 5
  }
});

export const ReceiptOrderDone = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  useMountEffect(async () => {
    if (!user) {
      await dispatch(logOut());
      navigate('/login', {replace: true});
      return;
    }

    await dispatch(logOut());
  });

  return (<>
    <Header showLogout={true} />
    <Container>
    <Card className={classes.card}>
      <CardBody className={classes.cardBody}>
        <Title className={classes.colorSuccess}>
          Formulář byl úspěšně odeslán
          <Check fontSize='large'
                 className={classes.successIcon} />
        </Title>
        <p className={classes.paragraph}>
          Úspěšně jsme přijali Vaší žádost o vystavení eReceptu.
        </p>
      </CardBody>
    </Card>
  </Container>
  </>);
};
